import React from 'react';

interface LogoProps {
  className?: string;
  inverted?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ className = '', inverted = false }) => {
  return (
    <svg
      viewBox="0 0 140 60"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#5B9BD5', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#4A90E2', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="logoGradientInverted" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#2C3539', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#3A4A54', stopOpacity: 1 }} />
        </linearGradient>
      </defs>

      {/* Abstract background: overlapping rounded shapes (terracotta, teal, mustard) */}
      <g aria-hidden="true">
        <rect
          x="0"
          y="2"
          width="52"
          height="52"
          rx="16"
          fill={inverted ? '#e0a080' : '#c4845c'}
          fillOpacity={inverted ? 0.25 : 0.4}
        />
        <rect
          x="18"
          y="0"
          width="50"
          height="50"
          rx="18"
          fill={inverted ? '#5d9a9a' : '#3d7070'}
          fillOpacity={inverted ? 0.25 : 0.35}
        />
        <rect
          x="70"
          y="8"
          width="70"
          height="48"
          rx="18"
          fill={inverted ? '#e8c55a' : '#d4ad3a'}
          fillOpacity={inverted ? 0.25 : 0.35}
        />
        <rect
          x="88"
          y="0"
          width="52"
          height="56"
          rx="20"
          fill={inverted ? '#6a7a8e' : '#4a5a6e'}
          fillOpacity={inverted ? 0.2 : 0.3}
        />
      </g>

      {/* JBM Letters - Bold, italic */}
      <text
        x="5"
        y="48"
        fontFamily="system-ui, -apple-system, 'Helvetica Neue', sans-serif"
        fontSize="56"
        fontWeight="900"
        fill={inverted ? 'url(#logoGradientInverted)' : 'url(#logoGradient)'}
        fontStyle="italic"
        letterSpacing="-3"
      >
        JBM
      </text>
    </svg>
  );
};
